// Vue Auth - Configuração para Vue 3 com @websanova/vue-auth v4
import { createAuth, useAuth } from '@websanova/vue-auth'
import { authAxiosInstance, plainAxiosInstance } from '@/api/http'
import router from '@/router'

// Criar instância de auth
const auth = createAuth({
  plugins: {
    http: authAxiosInstance,
    router: router,
  },
  drivers: {
    http: require('@websanova/vue-auth/dist/drivers/http/axios.1.x.js'),
    auth: require('@websanova/vue-auth/dist/drivers/auth/bearer.js'),
    router: require('@websanova/vue-auth/dist/drivers/router/vue-router.2.x.js'),
  },
  options: {
    loginData: {
      url: "/auth/sign_in",
      method: "POST",
      redirect: "/",
    },
    logoutData: {
      url: "/auth/sign_out",
      method: "DELETE",
      redirect: "/login",
    },
    registerData: {
      url: "/auth",
      method: "POST",
    },
    refreshData: {
      url: "/auth/validate_token",
      method: "GET",
      enabled: true,
      interval: 30,
    },
    fetchData: {
      url: "/auth/validate_token",
      method: "GET",
      enabled: true,
    },
    // Configurações de token
    tokenDefaultKey: 'default_auth_token',
    tokenStore: ['localStorage'],
    parseUserData: function(response) {
      return response.data;
    },
  }
})

// Após login bem-sucedido, sincronizar com vue-auth
authAxiosInstance.interceptors.response.use(
  response => {
    // Se tem access-token no header, é resposta de login
    if (response.headers['access-token']) {
      // Notifica vue-auth sobre o login
      auth.refresh()
        .then(() => console.log('Auth refreshed'))
        .catch(err => console.log('Auth refresh error:', err))
    }
    return response
  },
  error => Promise.reject(error)
)

export { auth, useAuth }
export default auth
